$.fn.layerednav = function(option) {

  const self = this
  const opt = $.extend(true, {
    current: false
  }, option, $(self).data())
  let depth = 0

  $(document).on('click touchend',(e) => {
    if (!$(e.target).closest('nav.p-gnav').length) {
      dismiss.call(document.querySelector('nav.p-gnav'),0)
    }
  });

  $(window).on('anchored', () => {
    dismiss.call(document.querySelector('nav.p-gnav'),0)
  });

  // 階層コンテナを生成する
  const makeLayer = (obj, depth) => {
    const $list = $(obj).children('li.menu-item-has-children'),
          $container = $('<nav />',{class:`p-gnav__sub is-depth-${depth} ${opt.classes[depth]}`}),
          $closeBtn = $('<a/>',{class:'btn btn-link btn-close'}).html('<i class="fa fa-times-circle"></i>'),
          $titlearea = $('<h3 />',{class:'d-block d-lg-none p-gnav__title'})
    
    if( $list.length == 0 ) return false

    depth ++

    // closeBtn挿入
    $closeBtn.on('click',function(){
      dismiss.call($container.parent(), depth)
    }).prependTo($container)

    // トグルボタン挿入、クリックイベント設定
    $list.children('a').each(function(){
      const $sublist = $(this).next('ul'),
            $btn = $('<a />',{href:'javascript:void(0)',class:'btn btn-link btn-expand'}).html('<span class="line"/><span class="line"/>')
      $btn.insertAfter(this)
      if(isTouchDevice()){
        $btn.on('touchend', function() {
          toggleMenu($container, $sublist, this, depth)
          return false
        })
      }else{
        $btn.on('mouseover', function () {
          openMenu($container, $sublist, this, depth)
        })
      }
    })

    //sp用タイトルエリア挿入
    $list.find('ul.sub-menu').each(function(){
      if( $('.p-gnav__title',this).length == 0 )
      $titlearea.clone().prependTo(this)
    })

    // サブメニュー移動とタイトル挿入
    $list.children('ul').each(function () {
      const $self = $(this),
            $this_container = $self.closest('nav')
      $('.p-gnav__title',this).append(function(){

        $(this).children('[data-step][data-depth]').each(function () {
          this.dataset.step = parseInt(this.dataset.step) + 1;
          this.dataset.depth = parseInt(this.dataset.depth) + 1;
        })

        const $text = $('<strong />').text($self.parent().children('a:first-child').text()),
              $dismis = $('<a>',{href:'#',class:`btn btn-link`}).html('<i class="fa fa-long-arrow-left" aria-hidden="true"></i>')
        $dismis.on('click',function(){
          const step = parseInt(this.parentNode.dataset.step)
          const depth = parseInt(this.parentNode.dataset.depth)
          dismiss.call($this_container, depth, step)
          return false
        });
        return $('<div />',{'data-step':1,'data-depth':depth,class:'p-gnav__title__sub'}).append($dismis).append($text)
      })
      $(this).appendTo($container)
    })

    // 再帰的にサブメニュー作成
    $container.children('ul').each(function(){
      makeLayer( this ,depth)
    })
    $(obj).parent().append($container)
    
  }

  const toggleMenu = function($cont,$list,trig,depth) {
    let state = $(trig).parent().attr('class').match(/is-[^\s]+/)||'';
    if( state !== '') state = state[0];
    if ($list.is(':hidden')) {
      $cont.parent().find('a.active,li.active').removeClass('active')
      $(trig).addClass('active').parent().addClass('active')
      $cont.addClass('open').find('ul').removeClass('show')
      $('.p-gnav').addClass(`is-open-depth-${depth-1}`)
      $list.addClass('show')
      $cont.removeClass('is-center is-mariya is-makuhari is-makuhari2 is-kohitsuji')
      $cont.addClass(state)
    } else {
      $(trig).removeClass('active').parent().removeClass('active')
      $cont.removeClass('open').find('.p-gnav__sub').removeClass('open')
      $('.p-gnav').removeClass(`is-open-depth-${depth-1}`)
      $cont.find('.show').each((i,v)=> v.classList.remove('show'))
      $cont.removeClass(state)
    }
    $cont.find('.p-gnav__sub').each(function () {
      if ($(this).find('.show').length == 0) $(this).removeClass('open')
    })
  }

  const openMenu = function($cont,$list,trig,depth) {
    let state = $(trig).parent().attr('class').match(/is-[^\s]+/)||'';
    if( state !== '') state = state[0];
    $cont.parent().find('a.active,li.active').removeClass('active')
    $(trig).addClass('active').parent().addClass('active')
    $cont.addClass('open').find('ul').removeClass('show')
    $('.p-gnav').addClass(`is-open-depth-${depth-1}`)
    $list.addClass('show')
    $cont.removeClass('is-center is-mariya is-makuhari is-makuhari2 is-kohitsuji')
    $cont.addClass(state)
    $cont.find('.p-gnav__sub').each(function () {
      if ($(this).find('.show').length == 0) $(this).removeClass('open')
    })
  }

  const dismiss = function (depth,step=1) {
    let i = step
    let $this = $(this)
    while(i > 0){
      $this.find('.p-gnav__sub').each(function () {
        $(this).find('.sub-menu.show').removeClass('show')
      })
      $this.find('.p-gnav__sub').each(function () {
        $(this).removeClass('open')
        if (!isNaN(depth)) $('.p-gnav').removeClass(`is-open-depth-${depth-1}`)
        if (depth == 0) $('.p-gnav').removeClass(function (i, className) {
          return (className.match(/\bis-open-depth-\d+/g) || []).join(' ');
        })
      })
      $this.children('.p-gnav__inner').children('ul').find('.active').each(function(){
        $(this).removeClass('active')
      })
      $this = $this.closest('nav')
      depth--
      i--
    }
    
  }

  const isTouchDevice = function() {
    var result = false;
    if (window.ontouchstart === null) {
      result = true;
    }  
    return result;
  }

  if( opt.current ){
    const path = location.pathname
    self.find('a[href]').each((i,v)=>{
      const href = v.href.replace(/^https?:\/\//,'').replace(location.host,'')
      if(path === href) v.parentNode.classList.add('current')
    })
  }

  return self.each(()=>{
    $(this).addClass(opt.classes[depth])
    depth++
    makeLayer(self,depth)

  })
  
  
}